<div class="wrapper d-flex flex-column gap-3">
  <div class="d-flex flex-row justify-content-between align-items-center">
    <button class="d-flex flex-row align-items-center back-btn" (click)="back()">
      <img src="assets/images/svg-icons/left-arrow.svg" alt="" srcset="" />
      {{"back" | translate | titlecase}}
    </button>
  </div>
  <div class="spin-win-container" id="spinnerContainer" #spinnerContainer>
    <div class="spinner-container">
      <div #spinner id="spinner"></div>
      <div *ngIf="fetchingAssets || lootboxFetchError" class="spinner-overlay">
        <ng-container *ngIf="fetchingAssets; else lootboxFetchError">
          <div class="spinner"></div>
        </ng-container>
        <ng-template #lootboxFetchError>
          <h4 class="error-text">Oops! Something went wrong.</h4>
        </ng-template>
      </div>
    </div>
    <svg-icon [src]="
        !sound.volume
          ? 'assets/images/prize-spinner/speaker-muted.svg'
          : 'assets/images/prize-spinner/speaker.svg'
      " alt="speaker" width="16" height="16" class="speaker" style="cursor: pointer"
      [svgStyle]="{'width.px': 16, 'height.px': 16}"
      (click)="!sound.volume ? (sound.volume = 1) : (sound.volume = 0)" />
  </div>
  <div class="spin-action-btns">
    <div class="spin-btn-wrapper d-flex flex-column gap-3 align-items-center" [ngStyle]="{'left':getSpinBtnAlignment}">
      <div class="spin-btns d-flex gap-sm-3 gap-3 align-items-center">
        <button class="spin-btn primary-btn" [ngClass]="{ 'p-t-12': (!checkingBalance && !fetchingAssets) }"
          (click)="checkBalanceAndSpin()"
          [disabled]="running || spinHasError || lessBalance || checkingBalance || !gameSession || fetchingAssets">
          <ng-container *ngIf="(!checkingBalance && !fetchingAssets); else spinBtnLoading" translate>{{"spin" |
            uppercase}}</ng-container>
          <ng-template #spinBtnLoading>
            <img src="assets/images/button-loader.gif" alt="Loading..." class="spin-btn-loader" />
          </ng-template>
        </button>
        <button *ngIf="!isProd" class="btn try-spin-btn primary-outline-btn"
          [ngStyle]="{'opacity': running ? '0.5' : '1'}" (click)="running ? '' : processSpin(true)" translate>try_it
        </button>
      </div>
      <div class="insufficient-balance d-flex flex-column gap-sm-1 align-items-center" *ngIf="lessBalance">
        <span class="balance-error-txt" translate>insufficient_balance</span>
        <span class="recharge-balance"><a href="https://www.wsmcasino.com/en?openCashier=true" target="_parent">{{"add"
            | translate |
            titlecase}}</a>
          {{ spinFee || 100 | currency : isUSDDefault ? CURRENCY.USD : CURRENCY.EURO }}
          {{ "start_spinning" | translate }}</span>
      </div>
    </div>
    <div class="spin-btn-container">
      <div class="price-container">
        <div>
          <span class="price-label title-text">Balance:
            <span class="price">{{isUSDDefault ? CURRENCY_SYMBOL.USD : CURRENCY_SYMBOL.EURO}}{{
              convertNum(userBalance
              || 0) }}</span></span>
        </div>
        <div class="free-spin-balance-wrapper d-flex flex-row align-items-center gap-sm-2 gap-2" *ngIf="sessionBalance[lootboxId]?.currentSessionFreeSpinBalance || marketingFreeSpinBalance">
          <img src="assets/images/svg-icons/refresh-icon.svg" alt="" />
          <span class="free-spin-label">{{ "free" | translate | titlecase }}&nbsp;{{ "spin" | translate |
            titlecase}}:<span class="free-spin-count">&nbsp;{{marketingFreeSpinBalance + (sessionBalance[lootboxId]?.currentSessionFreeSpinBalance || 0)}}x</span></span>
        </div>
      </div>
      <div class="fast-spin-price-wrapper align-items-center gap-sm-2">
        <div class="fast-spin d-flex flex-row align-items-center gap-sm-2 gap-2">
          <div class="form-check form-switch" [ngClass]="{
              'cursor-not-allowed':running
            }">
            <!-- running || spinHasError || lessBalance || checkingBalance -->
            <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault"
              (change)="isFastSpin = !isFastSpin" [disabled]="running" />
          </div>
          <label class="form-check-label" for="flexSwitchCheckDefault" translate>{{ "fast" | translate | titlecase
            }}&nbsp;{{ "spin" | translate | titlecase}}</label>
        </div>

        <div class="price-container">
          <span class="price-label title-text">{{ "price" | translate }}:
            <span class="price">{{isUSDDefault ? CURRENCY_SYMBOL.USD : CURRENCY_SYMBOL.EURO}}{{ convertNumToCurr(spinFee
              || 0) }}</span></span>
        </div>
      </div>
    </div>
  </div>
  <div class="lootbox-contents-container d-flex flex-column gap-sm-2">
    <h5 class="lootbox-contents-title">{{"lootbox_contents" | translate | uppercase}}</h5>
    <div class="contents-wrapper" *ngIf="!fetchingDetails; else fetchingDetailsLoader">
        <app-reward-card *ngFor="let card of cards" [cardDetails]="card" (onAction)="onAction(card)"></app-reward-card>
    </div>
    <ng-template #fetchingDetailsLoader>
      <app-loader [isLoading]="fetchingDetails" class="d-flex flex-row justify-content-center w-100 lootbox-loader"
      [loaderConfig]="{ height: 64, thickness: 4, isDarkBg:true }"></app-loader>
    </ng-template>
  </div>
</div>
<!-- PRELOADS IMAGES WHICH NEEDS TO BE SHOWN IN SPIN WIN POP-UP  -->
<img [src]="spinWinBg" *ngIf="spinWinBg" alt="" srcset="" class="d-none">
<img [src]="prizeBg" *ngIf="prizeBg" alt="" srcset="" class="d-none">

<div *ngIf="!running && showCoinTransfer"
  class="d-flex flex-column justify-content-center align-items-center animation-overlay sell-nft-coins">
  <ng-lottie [options]="options"></ng-lottie>
</div>